import { createStore as createReduxStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import multi from 'redux-multi';
import effects from 'redux-effects';
import promise from 'redux-promise';
import thunk from 'redux-thunk';
import { localstorage } from 'optilit-frontend-helpers';
import { save } from 'redux-localstorage-simple';
import { http, stripe, location } from 'optilit-redux-middleware';
import createHttpClient from 'optilit-http-client';
import rootReducer from '../reducer';
import * as actionTypes from '../actions/types';
import initialState from './initialState';

const NAMESPACE = `${process.env.REACT_APP_COMPANY}_webshop`;
/*const trackingSocket = io(
  `${process.env.REACT_APP_ANALYTICS_SOCKET_ENDPOINT}`,
  {
    path: "/analytics",
  }
);*/

const httpClient = createHttpClient({
  baseURL: process.env.REACT_APP_HTTP_BASE_URL,
});

const loadInitialState = () => {
  const token = localstorage.getItem('auth_token');
  let appData;
  let loginRequired;
  if (!token) {
    loginRequired = 'loginRequired';
    appData = initialState.data;
  } else {
    loginRequired = null;
    appData = localstorage.getItem(`${NAMESPACE}_data`);
  }

  return {
    ...initialState,
    status: { ...initialState.status, auth: loginRequired },
    data: { ...appData },
  };
};

const preloadedState = loadInitialState();

const createStore = () =>
  createReduxStore(
    rootReducer,
    preloadedState,
    applyMiddleware(
      effects,
      thunk,
      promise,
      logger,
      multi,
      stripe({
        actionType: actionTypes.CREATE_STRIPE_SOURCE,
      }),
      http.middleware(httpClient),
      save({
        namespace: NAMESPACE,
        states: ['data'],
      }),
      location
      //analyticsEmit(trackingSocket, actionTypes.INIT_SOCKET)
    )
  );

export default createStore;



// WEBPACK FOOTER //
// ../shop_main/store/index.js